// Vendors
import { deviceUtils } from '@openbank/cf-ui-architecture-core';
// Enumerations
import { UploadIdStatesEnumeration } from 'containers/upload-id/enumerations/upload-id-states.enumeration';
// Resolvers
import { generateVerificationExpressIdUrlResolver } from '../resolvers/upload-id-landing.resolver';
// Translations
import { TAKE_A_PHOTO } from './translations/upload-id-landing.handlers.translations';
// Types
import { UploadIdVerificationInformationType } from 'containers/upload-id/contexts/types/upload-id.contexts.type';
import {
  UploadIdLandingBuilderHandlersType,
  UploadIdLandingButtonConfigurationHandlersType,
  UploadIdLandingMethodsHandlersType,
} from './types/upload-id-landing.handlers.type';

const updateButtonWithFetchingState =
  () =>
  (
    previousConfiguration: UploadIdLandingButtonConfigurationHandlersType
  ): UploadIdLandingButtonConfigurationHandlersType => ({
    ...previousConfiguration,
    loading: true,
  });

const takeAPhotoButtonClickHandler = async ({
  setError,
  setMainButtonConfiguration,
  setUploadIdState,
  setVerificationInformation,
  handleContinueButtonClickTracking,
}: Omit<UploadIdLandingBuilderHandlersType, 'formatMessage'>): Promise<void> => {
  handleContinueButtonClickTracking();
  setMainButtonConfiguration(updateButtonWithFetchingState());

  const [response, error] = await generateVerificationExpressIdUrlResolver();

  if (error) {
    setError(true);
  } else {
    setUploadIdState(UploadIdStatesEnumeration.VERIFICATION);
    setVerificationInformation(response as UploadIdVerificationInformationType);
    setMainButtonConfiguration({});
  }
};

const setupUploadIdLandingButtonConfigurationHandler = ({
  formatMessage,
  setMainButtonConfiguration,
  handleContinueButtonClickTracking,
  ...restProps
}: UploadIdLandingBuilderHandlersType): void => {
  setMainButtonConfiguration({
    children: formatMessage({ id: TAKE_A_PHOTO }),
    onClick: () =>
      takeAPhotoButtonClickHandler({
        ...restProps,
        setMainButtonConfiguration,
        handleContinueButtonClickTracking,
      }),
  });
};

const responsiveHandler = ({ setCompactView }: UploadIdLandingBuilderHandlersType): void => {
  setCompactView(deviceUtils.isMobileDevice());
};

const enableCompactViewHandler = ({ setCompactView }: UploadIdLandingBuilderHandlersType): void => {
  setCompactView(true);
};

const UploadIdLandingHandlers = (
  props: UploadIdLandingBuilderHandlersType
): UploadIdLandingMethodsHandlersType => ({
  handleSetupUploadIdLandingButtonConfiguration: () =>
    setupUploadIdLandingButtonConfigurationHandler(props),
  handleResponsive: () => responsiveHandler(props),
  handleEnableCompactView: () => enableCompactViewHandler(props),
});

export { UploadIdLandingHandlers };
